import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import FR from 'vuetify/es5/locale/fr'
import EN from 'vuetify/es5/locale/en'
import DE from 'vuetify/es5/locale/de'
import HU from 'vuetify/es5/locale/hu'
import IT from 'vuetify/es5/locale/it'
import PL from 'vuetify/es5/locale/pl'
import SV from 'vuetify/es5/locale/sv'

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi', // default - only for display purposes
      },
      lang: {
        locales: {FR, EN, DE, HU, IT, PL, SV},
        current: 'EN'
      }
});
